import React, { useMemo } from 'react';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';
import Loader from '../../../common/Loader';
import { getAssetColor } from '../../../utils/common';
import { canAddAsset, eligibleForEditRmaDetails, eligibleForUpdateRmaDetails, MilestoneType, serviceTypeIds, ticketTypes } from '../TicketController';
import { useDispatch } from 'react-redux';
import UpdateRmaDetails from '../Modal/UpdateRmaDetails';
import { openCustomModal, openFullscreenModal } from '../../../actions/modal';
import { useNavigate } from 'react-router-dom';
import AssetHistory from '../../Inventory/reusableComponents/AddOption/AssetHistory';
import AssetPopup from '../../../common/Popups/AssetPop';
import IconToolTip from '../../../common/IconToolTip';
import { copyToClipboard } from '../../../actions/utils';
import { AddTicketAsset } from '../Modal/AddTicketAsset';
import UserPopup from '../../../common/Popups/User';

export const findAssetdublicetCount = (array) => {
    const serialNumberAssest =
        array?.filter((e) => {
            return e?.serial_number?.length > 3;
        }) || [];


    let withOutSerialNumberAssest =
        array?.filter((e) => {
            return !e?.serial_number || e?.serial_number?.length < 3;
        }) || [];

    const dublictAsset =
        withOutSerialNumberAssest?.reduce((acc, item) => {
            const findtitle = acc?.find(({ title }) => item?.assetType?.title === title || item?.title === title);
            if (findtitle) {
                findtitle.count++;
            } else {
                acc.push({
                    title: item?.assetType?.title || item.title, count: 1, status: item.status, is_spare: item.is_spare, fk_asset_id: item.fk_asset_id, working_condition
                        : item.working_condition
                });
            }

            return acc;
        }, []) || [];


    return [...serialNumberAssest, ...dublictAsset,];
};

export const AssetsColumn = ({ loading, ticket, dataToShowPerRow = 3 }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const assetList = ticket.assets || [];

    const showAddAsset = canAddAsset(ticket);
    const showUpdateRma = eligibleForUpdateRmaDetails(ticket.milestones, ticket.status, ticket.actions);
    const showEditRma = !showUpdateRma && eligibleForEditRmaDetails(ticket.milestones, ticket.status, ticket.actions);

    const openUpdateRmaModal = () => {
        let heading = (
            <span className='text-black'>
                Update RMA Details :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.job_ticket_number}</span>
            </span>
        );
        let modalWidth = '85rem';
        let modalHeight = 'auto';
        let modalComponent = <UpdateRmaDetails id={ticket.id} heading={"Update RMA Details"} />;
        dispatch(
            openFullscreenModal({
                heading,
                modalWidth,
                modalHeight,
                modalComponent,
            })
        );
    };


    const isRmaTicket = useMemo(() => {
        return ticket.milestones.find((mile) => mile.type === MilestoneType.RMA);
    }, [ticket.milestones]);

    if (loading) {
        return (
            <div className='relative w-4/12'>
                <Loader color={'#F48A21'} size='15' speed='1' thickness='2' />
            </div>
        );
    }

    const viewAssetHistory = (asset) => {
        if (asset.asset_id) {
            let modalComponent = <AssetHistory assetId={asset.asset_id} />;
            let modalWidth = '50em',
                modalHeight = '60vh';
            let head = (
                <span className='flex items-center font-medium'>
                    <span className='text-black'>Asset History</span>
                    <span className={`ml-2 pt-2 text-font14 font-semibold text-${getAssetColor(asset)}`}>
                        {asset?.asset?.serial_number}
                    </span>
                </span>
            );

            dispatch(openCustomModal({ modalComponent, heading: head, modalWidth, modalHeight }));
        }
    };

    const openAddAssetForm = () => {
        let modalComponent = <AddTicketAsset ticket={ticket} isRma />;
        let modalWidth = '60vw',
            modalHeight = 'auto';
        let head = <span>
            Add BOQ :
            <span className='text-scogobgsky'>{ticket.ticket_number}</span>
        </span>
        dispatch(openCustomModal({ modalComponent, heading: head, modalWidth, modalHeight }));
    }

    return (
        <div className='w-full'>
            {isRmaTicket && isRmaTicket?.dispatch_location?.external_id ? <div className=' w-[95%] truncate' >
                <UserPopup userId={isRmaTicket?.dispatch_location?.user_id} anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}>
                    <IconToolTip title={<>
                        Name: {isRmaTicket?.dispatch_location?.external_id || ''}
                        <br />
                        Address : {isRmaTicket?.dispatch_location?.address || ''}
                    </>
                    } >
                        <span
                            className={`bg-tagbg scogoprimary text-font10 px-2 py-1 rounded-3px max-w-full hover:text-scogoorange text-ellipsis truncate`}
                        >
                            {isRmaTicket?.dispatch_location?.external_id}
                        </span>
                    </IconToolTip>
                </UserPopup>
            </div> : <></>
            }

            <div className='flex-wrap flex items-center gap-x-1 mt-2'>
                {assetList.length > 0 &&
                    assetList?.slice(0, dataToShowPerRow)?.map((asset, index) => {
                        const status = `${asset?.status?.length > 0 ? ` ${asset?.status}` : ""}`
                        const workingStatus = `${asset?.working_condition?.length > 0 ? `, ${asset?.working_condition}` : ""}`;
                        return (
                            <IconToolTip open={true} key={index} title={<div className='flex items-center'>
                                {status} {workingStatus}
                            </div>} onClick={() => viewAssetHistory(asset)}>
                                <span className={`bg-${getAssetColor(asset)} cursor-pointer text-white max-w-12 text-font10 px-2 flex items-center rounded-3px mb-1 relative`}>
                                    <span className='max-w-4/5 truncate'  >
                                        {(asset?.asset?.serial_number?.length > 0 ? asset?.asset?.serial_number : asset?.asset?.asset_type?.title)}
                                    </span>
                                    {/* <span>
                                        {(asset?.count > 1 ? `: ${asset?.count}` : '')}
                                    </span> */}
                                    <span className="material-icons text-font12 ml-1 hover:text-scogobgsky" onClick={(event) => {
                                        event.stopPropagation();
                                        const text = asset?.asset?.serial_number?.length > 0 ? asset?.asset?.serial_number : asset?.asset?.asset_type?.title

                                        dispatch(copyToClipboard({ data: text }))
                                    }}>
                                        content_copy
                                    </span>
                                </span>
                            </IconToolTip>
                        );
                    })}

                {assetList?.length > dataToShowPerRow && (
                    <>
                        <AssetPopup ticket_id={ticket.id} assetList={assetList?.slice(dataToShowPerRow)} anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }} >
                            <span className='text-font12 round font-normal text-scogoorange relative cursor-pointer hover:text-scogobgsky countOfBOQ'>
                                +{assetList?.length - dataToShowPerRow}
                            </span>
                        </AssetPopup>
                    </>
                )}
            </div>
            <div className='flex flex-col gap-2 max-w-max'>
                {showAddAsset && <ButtonScogoOrange buttonClass='text-font11 max-w-max' textOrComponent={'Add Assets'} onClick={openAddAssetForm} />}
                {showUpdateRma && <ButtonScogoOrange buttonClass='text-font11 max-w-max' textOrComponent={'Update RMA'} onClick={openUpdateRmaModal} />}
                {showEditRma && <ButtonScogoOrange buttonClass='text-font11 max-w-max' textOrComponent={'Edit RMA'} onClick={openUpdateRmaModal} />}
            </div>
        </div>
    );
};
